import React from 'react';
import translate from '@/lib/intl/translate';
import FileUploader, { type FileUploadItem } from '@/modules/FileUploader';
import type AttachmentItem from '@/types/api/AttachmentItem';

export default function EntityDetailsFileUploader({
  attachments = [],
  onUploadFinished,
}: {
  attachments?: AttachmentItem[];
  onUploadFinished: (e: FileUploadItem[]) => void;
}) {
  return (
    <div className="mb-6">
      <h3 className="pb-4 text-base font-semibold">{translate('FILES')}</h3>

      <FileUploader
        multiple
        onUploadFinished={onUploadFinished}
        value={attachments}
      />
    </div>
  );
}
